export default __webpack_public_path__ + "static/media/11-SparTvis.069d2c66.png";